module.exports = __webpack_public_path__ + "static/media/Production.ac584fda.png";